<div class="grid">
	<div [ngClass]="col12Responsive()"
		[class]="!underTablet() ? 'flex justify-content-start' : 'flex justify-content-center'">
		<p-button id="addSupportRequestUser" label="{{ 'ADD_SUPPORT_REQUEST' | translate }}"
			(click)="addSupportRequestTicket()" icon="pi cm-plus" [rounded]="false" [text]="true" severity="primary"
			styleClass="font-bold border-primary surface-900 hover:bg-blue-900">
		</p-button>
	</div>
	<div [ngClass]="col12Responsive()"
		[class]="!underTablet() ? 'flex justify-content-end' : 'flex justify-content-center'">
		<span class="p-input-icon-left" [class]="dynamicInputTextWidth()">
			<i class="pi cm-search"></i>
			<input [formControl]="searchFilter" pInputText type="text" [ngClass]="dynamicInputTextWidth()" class="surface-900"
				id="supportrequest-user-input-search" placeholder="{{ 'SEARCH' | translate }}" maxlength="220" />
		</span>
	</div>
	<div class="col-12">
		<div class="card border-round">
			<p-table
				#tableTicketList
				dataKey="id"
				[value]="tickets"
				[lazy]="true"
				(onLazyLoad)="loadTickets($event)"
				[paginator]="true"
				[totalRecords]="totalRecords"
				[loading]="ticketsLoading"
				[rows]="pageSize"
				[showCurrentPageReport]="true"
				currentPageReportTemplate="{{ 'TABLE_REPORT' | translate }}"
				[autoLayout]="true"
				sortField="CreatedAt" [sortOrder]="-1"
				responsiveLayout="stack">

				<ng-template pTemplate="header">
					<tr>
						<th>
							<div pSortableColumn="CreatedAt" class="flex align-items-center justify-content-center">
								{{ 'CREATION_REQUEST' | translate }}
								<p-sortIcon field="CreatedAt"></p-sortIcon>
							</div>
						</th>
						<th>
							<div pSortableColumn="Note" class="flex align-items-center justify-content-center">
								{{ 'COMMENT' | translate }}
								<p-sortIcon field="Note"></p-sortIcon>
							</div>
						</th>
						<th>
							<div pSortableColumn="TechnicianFirstName" class="flex align-items-center justify-content-center">
								{{ 'TECHNICIAN' | translate }}
								<p-sortIcon field="TechnicianFirstName"></p-sortIcon>
							</div>
						</th>
						<th>
							<div pSortableColumn="FlagClosed" class="flex align-items-center justify-content-center">
								{{ 'FLAG_CLOSED' | translate }}
								<p-sortIcon field="FlagClosed"></p-sortIcon>
							</div>
						</th>
						<th>
							<div pSortableColumn="ClosingDate" class="flex align-items-center justify-content-center">
								{{ 'CLOSE_REQUEST' | translate }}
								<p-sortIcon field="ClosingDate"></p-sortIcon>
							</div>
						</th>
						<th>
							<div pSortableColumn="SiteName" class="flex align-items-center justify-content-center">
								{{ 'SITE' | translate }}
								<p-sortIcon field="SiteName"></p-sortIcon>
							</div>
						</th>
						<th>
							<div pSortableColumn="TotalAccessExpDate" class="flex align-items-center justify-content-center">
								{{ 'GRANT_ACCESS' | translate }}
								<p-sortIcon field="TotalAccessExpDate"></p-sortIcon>
							</div>
						</th>
					</tr>
				</ng-template>
				<ng-template pTemplate="body" let-ticket>
					<tr>
							<td>
									<span class="p-column-title font-semibold">{{ 'CREATION_REQUEST' | translate }}</span>{{ticket.CreatedAt | localizedDate:'shortDate' }}
							</td>
							<td>
									<span class="p-column-title font-semibold">{{ 'COMMENT' | translate }}</span>{{ticket.Note | truncate:[100]}}
							</td>
							<td>
									<span class="p-column-title font-semibold">{{ 'TECHNICIAN' | translate }}</span>{{ticket.TechnicianFirstName + ' ' + ticket.TechnicianLastName}}
							</td>
							<td>
									<span class="p-column-title font-semibold">{{ 'FLAG_CLOSED' | translate }}</span>
									<p-tag [value]="ticket.FlagClosed? ('CLOSED' | translate) : ('OPENED' | translate)"
									[severity]="ticket.FlagClosed? 'danger' : 'success'"></p-tag>
							</td>
							<td>
									<span class="p-column-title font-semibold">{{ 'CLOSE_REQUEST' | translate }}</span>{{ticket.ClosingDate ? (ticket.ClosingDate | localizedDate: 'medium') : '--' }}
							</td>
							<td>
									<span class="p-column-title font-semibold">{{ 'SITE' | translate }}</span>{{ticket.SiteName || '' }}
							</td>
							<td>
									<span class="p-column-title font-semibold">{{ 'GRANT_ACCESS' | translate }}</span>{{ticket.TotalAccessExpDate | localizedDate: 'mediumDate' }}
							</td>
							<td>
									<span class="p-column-title"></span>
									<div class="flex flex-row justify-content-center align-items-center ">
									<p-button pTooltip="{{'TICKET_DETAILS' | translate}}" tooltipPosition="bottom" icon="pi cm-info" (click)="infoTicket(ticket)" 
										[rounded]="false" [text]="true" severity="primary" size="large">
									</p-button>
									<p-button pTooltip="{{'CLOSE_TICKET' | translate}}" tooltipPosition="bottom" icon="pi cm-cancel" (click)="closeTicket(ticket)" 
										[rounded]="false" [text]="true" severity="danger" size="large" [disabled]="ticket.FlagClosed">
									</p-button>
									</div>
							</td>
				</tr>
				</ng-template>
				<ng-template pTemplate="emptymessage">
					<tr>
						<td colspan="7">{{ 'TABLE_NO_ELEMENT' | translate }}</td>
					</tr>
				</ng-template>
			</p-table>
		</div>
	</div>
</div>

<p-confirmDialog #confDialog>
	<ng-template pTemplate="footer">
		<div class="col-12 flex justify-content-center">
			<button type="button" pButton
				[label]="confDialog.acceptButtonLabel"
				[ngClass]="acceptButtonStyle"
				(click)="confDialog.accept()">
			</button>
			<button type="button" pButton
				[label]="confDialog.rejectButtonLabel"
				[ngClass]="rejectButtonStyle"
				(click)="confDialog.reject()">
			</button>
		</div>
	</ng-template>
</p-confirmDialog>
